import Breadcrumb from './../../components/BreadCrumb';
import ServiceComponent from './../../components/ServiceComponent';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';
import { faFileAlt, faBalanceScale, faUserTie } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/legal.jpg'

function ParalegalServiceScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Fixed Fee Legal Services'>
          <Breadcrumb parent="Services" screen='Fixed Fee Legal Services'/>
        </HeadingDetailsSection>
        <ServiceComponent
          heading="Paralegal Services"
          description="Access professional paralegal support on demand with PocketLPO’s Paralegal Services. Our team ensures efficient assistance for your legal needs without the cost of full-time staff."
          services={[
            "Document preparation and review.",
            "Case management and trial support.",
            "Legal research and summarization."
          ]}
          benefits={[
            { title: "Flexible Support", description: "Scale services based on your workload.", icon: faFileAlt },
            { title: "Cost Savings", description: "Affordable solutions compared to hiring in-house.", icon: faBalanceScale },
            { title: "Experienced Professionals", description: "Skilled paralegals for diverse legal tasks.", icon: faUserTie }
          ]}
          image={image}
        />
    </>
  );
}

export default ParalegalServiceScreen;
